import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { ApplicationsModule } from './modules/applications/applications.module';
import { ErrorComponent } from './components/error/error.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { PostMessageComponent } from './components/postmessage/post-message.component';
import { ExpiredComponent } from './components/expired/expired.component';
import { ModuleRoutingConstants } from './core/helpers/module-routing.constants';
import { AppReadyGuard } from './core/services/app-ready.guard';
import { LoadingScreenComponent } from './components/loading-screen/loading-screen.component';
import { LogoutScreenComponent } from './components/logout-screen/logout-screen.component';

/**
 * Application routes:
 * - application: routes loaded eagerly, see bellow ApplicationsModule
 * - card - loaded lazily on demand
 * - requests - loaded lazily on demand
 */
const routes: Routes = [

    // pri pristupu do aplikace se musi zobrazit nejaka komponenta - nez url-params.effects. provedou redirect na jinou
    // routu; routa by nemela byt chranena guardem viz SSF-226
    { path: '', pathMatch: 'full', component: LoadingScreenComponent },

    { path: ModuleRoutingConstants.APPLICATIONS, loadChildren: () => ApplicationsModule },

    { path: ModuleRoutingConstants.CARD,
        loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./modules/card/card.module')['CardModule']);  });}),
        canActivate: [AppReadyGuard]},

    { path: ModuleRoutingConstants.HISTORY_OF_REQUESTS,
        loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./modules/history-requests/history-requests.module')['HistoryRequestsModule']);  });}),
        canActivate: [AppReadyGuard]},

    { path: ModuleRoutingConstants.BANK_IDENTITY,
        loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./modules/bank-identity/bank-identity.module')['BankIdentityModule']);  });})},

    { path: '500', component: ErrorComponent },
    { path: '401', component: UnauthorizedComponent },
    { path: 'logout', component: LogoutScreenComponent },
    { path: 'expired', component: ExpiredComponent },
    { path: 'postmessage', component: PostMessageComponent},
    { path: '**', component: NotFoundComponent },
];

@NgModule({
    imports: [ RouterModule.forRoot(routes, /*{ enableTracing: true }*/)],
    exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/app-routing.module.ts